import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";

export default function PageHeader({ title, back }) {
  return (
    <div className="mb-4 flex items-center gap-3">
      <Link to={back} data-testid="page-back" aria-label="Back"
        className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md border border-border text-muted-foreground transition-colors hover:text-foreground">
        <ArrowLeft size={20} weight="bold" />
      </Link>
      <h1 className="font-heading text-2xl font-bold tracking-tight" data-testid="page-heading">{title}</h1>
    </div>
  );
}
